export default "__VITE_ASSET__BvcwIaAY__"